import api, { endpoints } from '../api/config'
import { store } from '../store'
import { loginSuccess, loginFailure } from '../store/slices/authSlice'

export const checkAuthStatus = async () => {
  try {
    // Check if user is authenticated by calling a protected endpoint
    const response = await api.get('/api/auth/check')
    
    if (response.data.authenticated && response.data.user) {
      // User is authenticated, update Redux store
      store.dispatch(loginSuccess(response.data.user))
      return true
    } else {
      // Not authenticated, but don't treat as error
      store.dispatch(loginFailure('Not authenticated'))
      return false
    }
  } catch (error) {
    // Network or server error
    console.error('Auth check error:', error)
    store.dispatch(loginFailure('Not authenticated'))
    return false
  }
}

export const getCurrentUser = async () => {
  try {
    const response = await api.get('/api/auth/user')
    if (response.data.user) {
      store.dispatch(loginSuccess(response.data.user))
      return response.data.user
    }
    return null
  } catch (error) {
    return null
  }
} 